import React, { useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import Toast from "react-bootstrap/Toast";
import { registerForCorporateAccount, registerForPersonalAccount } from "../../network/ApiAxios";

import config from "../../config";
import { PencilAltIcon } from "@heroicons/react/outline";
import Select from "react-select";
import { options_Pays } from "options";
import LoginPostul from "components/Auth/loginPostul";
import useCustomTranslation from "components/Translation/useCustomTranslation";



const Register = (props) => {
  const {t} = useCustomTranslation()
  //shared
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  //Candidat
  const [email, setEmail] = useState("");
  const [studyLevel, setStudyLevel] = useState("");
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [adress, setAdress] = useState("");
  const [projets, setProjets] = useState("");
  //const [projet_France_CDI, set_Projet_France_CDI] = useState("");
  //const [projet_Etranger_hors_France_CDI, set_projet_Etranger_hors_France_CDI] = useState("");
  //admin
  const [company, setCompany] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [webSite, setWebSite] = useState("");
  const [activity, setActivity] = useState("");
  const [description, setDescription] = useState("");
  const [country, setCountry] = useState("");

  const [newAccountCreated, setNewAccountCreated] = useState(false);
  const [newEmployerAccountCreated, setNewEmployerAccountCreated] = useState(false);




  const [role, setRole] = useState("candidat");
  const [checkbox, setCheckbox] = useState(false);
  const [acceptNewsletterReception, setAcceptNewsletterReception] = useState(false);
  const [error, setError] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(
    "Email sent! Check it to reset your password."
  );
  const [userID, setUserID] = useState(null);
  const [type, setType] = useState("");

  const [formIsValid, setFormIsValid] = useState(true);
  const [formIsValidForEmployer, setFormIsValidForEmployer] = useState(true);
  const [openTab, setOpenTab] = React.useState(2);

  const options = [
    { value: "Agroalimentaire", label: "Agroalimentaire" },
    { value: "Banque / Assurance", label: "Banque / Assurance" },
    { value: "Bois/ Papier/ Carton/ Imprimerie", label: "Bois/ Papier/ Carton/ Imprimerie" },
    { value: "BTP/ Matériaux de construction", label: "BTP/ Matériaux de construction" },
    { value: "Chimie/ Parachimie", label: "Chimie/ Parachimie" },
    { value: "Commerce/ Négoce/ Distribution", label: "Commerce/ Négoce/ Distribution" },
    { value: "Édition/ Communication/ Multimédia", label: "Édition/ Communication/ Multimédia" },
    { value: "Électronique/ Électricité", label: "Électronique/ Électricité" },
    { value: "Études et conseils", label: "Études et conseils" },
    { value: "Industrie pharmaceutique", label: "Industrie pharmaceutique" },
    { value: "Informatique/ Télécoms", label: "Informatique/ Télécoms" },
    { value: "Machines et équipements/ Automobile", label: "Machines et équipements/ Automobile" },
    { value: "Métallurgie/ Travail du métal", label: "Métallurgie/ Travail du métal" },
    { value: "Plastique/ Caoutchouc", label: "Plastique/ Caoutchouc" },
    { value: "Services aux entreprises", label: "Services aux entreprises" },
    { value: "Textile/ Habillement/ Chaussure", label: "Textile/ Habillement/ Chaussure" },
    { value: "Transports/ Logistique", label: "Transports/ Logistique" },
    { value: "Autres", label: "Autres" },
  ];



  const handleCorporateAccountValidation = () => {
    let isValid = true;

    if (!country) {
      isValid = false;
      setFormIsValidForEmployer(false);
      setError("impossible de procéder avec pays vide ");
    }
    if (!company) {
      setFormIsValidForEmployer(false);
      isValid = false;
      setError("impossible de procéder avec Nom de l'entreprise vide ");
    }
    if (!email) {
      setFormIsValidForEmployer(false);
      isValid = false;
      setError("impossible de procéder avec un Email vide ");

      if (typeof email !== "undefined") {
        let lastAtPos = email.lastIndexOf("@");
        let lastDotPos = email.lastIndexOf(".");

        if (
          !(
            lastAtPos < lastDotPos &&
            lastAtPos > 0 &&
            email.indexOf("@@") == -1 &&
            lastDotPos > 2 &&
            email.length - lastDotPos > 2
          )
        ) {
          isValid = false;
          setFormIsValidForEmployer(false);
          setError("L'Email  n'est pas valide");
        }
      }

      console.log(error);

    }
    if (!lastName) {
      isValid = false;
      setFormIsValidForEmployer(false);
      setError("impossible de procéder avec un prénom vide ");
    }
    if (!firstName) {
      isValid = false;
      setFormIsValidForEmployer(false);
      setError("impossible de procéder avec un nom vide ");
    }

    return isValid;
  };
  const handlePersonalAccountValidation = () => {
    let isValid = true;


    if (!country) {
      isValid = false;
      setError("impossible de procéder avec un pays vide ");
    }
    if (!email) {
      isValid = false;
      setError("impossible de procéder avec un Email vide ");

      if (typeof email !== "undefined") {
        let lastAtPos = email.lastIndexOf("@");
        let lastDotPos = email.lastIndexOf(".");

        if (
          !(
            lastAtPos < lastDotPos &&
            lastAtPos > 0 &&
            email.indexOf("@@") == -1 &&
            lastDotPos > 2 &&
            email.length - lastDotPos > 2
          )
        ) {
          isValid = false;
          setError("L'Email n'est pas valide");
        }
      }

      console.log(error);

    }
    if (!lastName) {
      isValid = false;
      setError("impossible de procéder avec un prénom vide ");
    }
    if (!firstName) {
      isValid = false;
      setError("impossible de procéder avec un nom vide ");
    }

    return isValid;
  };
  const registerCorporateAccountFunction = async () => {
    // if (!(name && email && password && confirmPassword && checkbox)) {
    //     setError("Make sure to fill all the inputs and agree to the privacy policy");
    //     return;
    // }
    // console.log("formisvalid", handleEmployerValidation());
    console.log("33333333333333333333333: registerCorporateAccountFunction: ");
    handleCorporateAccountValidation();
    if (handleCorporateAccountValidation()) {

      if (password !== confirmPassword) {
        setError("Les mots de passe ne correspondent pas");
        return;
      }
      let Activity = activity.value
      const response = await registerForCorporateAccount(
        firstName,
        lastName,
        email,
        company,
        password,
        country,
      );
      const { data } = response;
      if (!data.success) {
        setError(data.msg);
        return;
      }
      if (config.DEMO) {
        setToastMessage(
          "Votre compte a été créé avec succès !"
        );
        setUserID(data.userID);
      }
      setNewEmployerAccountCreated(true);
      setError("");
      setFirstName("");
      setEmail("");
      setCompanyEmail("");
      setCompany("");
      setLastName("");
      setCountry("");
      setPassword("");
      setConfirmPassword("");
      setCheckbox(false);
      setShowToast(true);
    } else {
      console.log("errored");
    }
  };
  const registerPersonalAccountFunction = async () => {
    // if (!(name && email && password && confirmPassword && checkbox)) {
    //     setError("Make sure to fill all the inputs and agree to the privacy policy");
    //     return;
    // }
    // console.log("0000000000000000000: register: ");
    // console.log("0000000000000000000: register: firstName: ", firstName);
    // console.log("formisvalid", handlePersonalAccountValidation());
    handlePersonalAccountValidation();
    if (handlePersonalAccountValidation()) {

      if (password !== confirmPassword) {
        setError("Les mots de passe ne correspondent pas");
        return;
      }

      const response = await registerForPersonalAccount(
        firstName,
        lastName,
        email,
        password,
        country,
        acceptNewsletterReception
      );
      const { data } = response;
      {/* console.log("99999999999999 country: ", country); */ }
      {/* console.log("99999999999999 response: ", response); */ }
      if (!data.success) {
        setError(data.msg);
        return;
      }
      if (config.DEMO) {
        setToastMessage(
          "Votre compte a été créé avec succès !"
        );
        setUserID(data.userID);

      }
      setNewAccountCreated(true);
      setError("");
      setFirstName("");
      setLastName("");
      setEmail("");
      setPassword("");


      setConfirmPassword("");
      setCheckbox(false);
      // setShowToast(true);
      setCountry("");
      setProjets("");
    } else {
      console.log("errored");
    }
  };

  return (
    <>
      <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: "fixed",
          minHeight: "100px",
          width: "35%",
          right: 10,
          bottom: 80,
          zIndex: 50,
        }}
      >
        <Toast
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: "white",
            padding: 10,
            borderRadius: 10,
          }}
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={10000}
          autohide={!config.DEMO}
        >
          <Toast.Header>
            {/* <img
              style={{ height: "30px", width: "100px" }}
              src={require("assets/img/brand/argon-react.png").default}
              alt="..."
            /> */}
            <h3>Welcome</h3>
          </Toast.Header>
          <Toast.Body>
            {toastMessage} <br />
            {(config.DEMO) ? (
              <a href={config.DOMAIN_NAME + "/auth/login"}>
                {t`Login`} ?
              </a>
            ) : null}
          </Toast.Body>
        </Toast>
      </div>
      <Col lg="8" md="7">
        <Card className="bg-secondary shadow border-0">

          {/* <CardHeader className="bg-transparent pb-5">
            <div className="w-full">
              <ul
                className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                role="tablist"
              >
                <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    className={
                      "text-sm uppercase px-5 py-3 shadow-lg rounded block leading-normal "
                    }
                    style={openTab === 1 ? { color: "white", backgroundColor: "#5e72e4" } : { color: "#5e72e4", backgroundColor: "white" }}
                    onClick={e => {
                      e.preventDefault();
                      setOpenTab(1);
                      setRole("Corporate");
                    }}
                    data-toggle="tab"
                    href="#link1"
                    role="tablist"
                  >
                    Entreprise ?
                  </a>
                </li>
                <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    className={
                      "text-sm  uppercase px-5 py-3 shadow-lg rounded block leading-normal "}
                    style={openTab === 2 ? { color: "white", backgroundColor: "#5e72e4" } : { color: "#5e72e4", backgroundColor: "white" }}
                    onClick={e => {
                      e.preventDefault();
                      setOpenTab(2);
                      setRole("candidat");
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    Particulier ?
                  </a>
                </li>

              </ul>

            </div>
          </CardHeader> */}




          <CardBody className="px-lg-5 py-lg-5">


            {/* candidat */}

            <div className={"block"} id="link2">
              {!newAccountCreated &&
                <>
                  {/* <h3 className="text-center"> S'inscrire en tant qu' utilisateur :</h3> */}
                  <Form role="form">
                    <FormGroup>
                      <InputGroup className="input-group-alternative mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <PencilAltIcon />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder={t`firstname`}
                          type="text"
                          value={firstName}
                          required
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <InputGroup className="input-group-alternative mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <PencilAltIcon />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder={t`lastname`}
                          type="text"
                          value={lastName}
                          required
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>


                    <FormGroup>
                      <InputGroup className="input-group-alternative mb-3">
                        <InputGroupAddon addonType="prepend">

                        </InputGroupAddon>
                        <label className="px-lg-3">{t`Country`}</label>
                        <Select className="w-full "
                          options={options_Pays}

                          onChange={(e) => {
                            setCountry(e.value);
                          }} />
                      </InputGroup>
                    </FormGroup>

                    <FormGroup>
                      <InputGroup className="input-group-alternative mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <PencilAltIcon />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Email"
                          type="email"
                          autoComplete="new-email"
                          value={email}
                          required
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>

                    <FormGroup>
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <PencilAltIcon />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder={t`password`}
                          type="password"
                          autoComplete="new-password"
                          value={password}
                          required
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <PencilAltIcon />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder={t`ConfirmPassword`}
                          type="password"
                          autoComplete="new-password"
                          value={confirmPassword}
                          required
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                    {error ? (
                      <div className="text-muted font-italic">
                        <small>
                          error:{" "}
                          <span className="text-red font-weight-700">{error}</span>
                        </small>
                      </div>
                    ) : null}
                    <Row className="my-4">
                      <Col xs="12">
                        <input
                          //className="custom-control-input"
                          id="customCheckRegister"
                          type="checkbox"
                          checked={checkbox}
                          onChange={() => setCheckbox(!checkbox)}
                        />
                        <label
                          //className="custom-control-label"
                          //htmlFor="customCheckRegister"
                        >
                          <span className="text-muted">
                            {t`CGVacceptance`} {" "}
                            <a href="https://topdevacademy.com/politique-de-confidentialite-cgv" target="_blank" rel="noopener noreferrer">
                              CGV
                            </a>
                          </span>
                        </label>

                      </Col>
                    </Row>
                    <Row className="my-4">
                      <Col xs="12">
                          <input
                            //className="custom-control-input"
                            id="acceptNewsletterReception"
                            type="checkbox"
                            checked={acceptNewsletterReception}
                            onChange={() => setAcceptNewsletterReception(!acceptNewsletterReception)}
                          />
                          <label
                          //className="custom-control-label"
                          //htmlFor="customCheckRegister"
                          >
                            <span className="text-muted">

                              {t`NewsletterAcceptance`}

                            </span>
                          </label>
                      </Col>
                    </Row>
                    <div className="text-center">
                      <Button
                        style={{

                          width: "100%",
                        }}
                        onClick={() => {

                          registerPersonalAccountFunction();
                        }}
                        className="mt-4"
                        color="primary"
                        type="button"
                      >
                        {t`CreateAccount`}
                      </Button>
                    </div>
                  </Form>
                </>

              }
              {newAccountCreated &&
                <>
                  <p>{t`CreateAccountMessage`}</p>
                  <LoginPostul /*id={props.id} redirect={"job"}*/ />
                </>

              }
            </div>

            {/* Corporate */}
            {/* <div className={openTab === 1 ? "block" : "hidden"} id="link1">
              <h3 className="text-center"> S'inscrire en tant qu'entreprise:</h3>
              <Form role="form">
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Prénom"
                      type="text"
                      value={firstName}
                      required
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Nom"
                      type="text"
                      value={lastName}
                      required
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email"
                      type="email"
                      autoComplete="new-email"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>

                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Nom de l’entreprise"
                      type="text"
                      value={company}
                      required
                      onChange={(e) => setCompany(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
                {/*
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email de l’entreprise"
                      type="email"
                      autoComplete="new-email"
                      value={companyEmail}
                      required
                      onChange={(e) => setCompanyEmail(e.target.value)}
                    />
                  </InputGroup>
              </FormGroup>
              
              
              <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <PencilAltIcon />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Numéro de téléphone de l'entreprise"
                    type="number"
                    value={phone}
                    required
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
            
                
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Site WEB"
                      type="text"
                      value={webSite}
                      required
                      onChange={(e) => setWebSite(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
            
                
                          <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    
                  </InputGroupAddon>
                  {/* <Input
                    placeholder="Secteur d’activité"
                    type="text"
                    value={activity}
                    required
                    onChange={(e) => setActivity(e.target.value)}
                  /> 
                <label className="px-lg-3">Secteur d’activité</label>
                   <Select className="w-full "
                          options={options}
                          
                          onChange={(e) => {
                            setActivity(e);
                            }} />
                </InputGroup>
              </FormGroup>
            


                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                    </InputGroupAddon>
                    <label className="px-lg-3">Pays</label>
                    <Select
                      className="w-full "
                      options={options_Pays}

                      onChange={(e) => {
                        setCountry(e.value);
                      }}
                    />
                  </InputGroup>
                </FormGroup>
                {/*
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend"></InputGroupAddon>
                    <label className="px-lg-3">Description de l’entreprise</label>
                    <textarea
                      style={{ width: "100%", height: "70px" }}
                      placeholder=""
                      type="text"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
              *

                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Mot de passe"
                      type="password"
                      autoComplete="new-password"
                      value={password}
                      required
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <PencilAltIcon />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Confirmer mot de passe"
                      type="password"
                      autoComplete="new-password"
                      value={confirmPassword}
                      required
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
                {error ? (
                  <div className="text-muted font-italic">
                    <small>
                      error:{" "}
                      <span className="text-red font-weight-700">{error}</span>
                    </small>
                  </div>
                ) : null}
                <Row className="my-4">
                  <Col xs="12">
                    <div className="custom-control custom-control-alternative custom-checkbox">
                      <input
                        className="custom-control-input"
                        id="customCheckRegister"
                        type="checkbox"
                        checked={checkbox}
                        onChange={() => setCheckbox(!checkbox)}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customCheckRegister"
                      >
                        <span className="text-muted">
                          I agree with the{" "}
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            Privacy Policy
                          </a>
                        </span>
                      </label>
                    </div>
                  </Col>
                </Row>
                <div className="text-center">
                  <Button
                    style={{

                      width: "100%",
                    }}
                    onClick={() => {

                      registerCorporateAccountFunction();
                    }}
                    className="mt-4"
                    color="primary"
                    type="button"
                  >
                    Créer mon compte
                  </Button>
                </div>
              </Form>
            </div> */}
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Register;
